import React, { useContext, useState } from "react";
import { StoreContext } from "../../../../storeroom/StoreContext";
import { Section, sectionBodyStyle } from "../../../base/Section";
import { Typography } from "@material-ui/core";
import ListingOtherNotesForm from "../forms/ListingOtherNotesForm";

export default function NotesSection() {
  const store = useContext(StoreContext);
  const listing = store.listingStore.listing;

  const [showEditForm, setShowEditForm] = useState(false);

  return (
    <Section
      header={"Other Notes"}
      actionIcon={"edit"}
      actionLabel={"Edit Other Notes"}
      onActionClick={() => setShowEditForm(true)}
    >
      <ListingOtherNotesForm
        show={showEditForm}
        onClose={() => setShowEditForm(false)}
      />
      <Typography style={sectionBodyStyle}>{listing.other_notes}</Typography>
    </Section>
  );
}
